<template>
    <sa-page-layout :btnBackVisible="true" :btnRefreshVisible="true" :linkback="linkback" :pathResource="pathResource" :showModalLoading="showModalLoading" @refresh="onRefresh">
        <template slot="toolbar-title">
            <rsa-ospite-anagrafica-component :jsonData="jsonData"></rsa-ospite-anagrafica-component>
        </template>

        <template slot="table-body">
            <rsa-paziente-scheda-aachener-aphasie-test-list-component
                ref="cmpRsaPazienteSchedaAachenerAphasieTestList"
                @beforeLoadData="onBeforeLoadData"
                @afterLoadData="onAfterLoadData"
            ></rsa-paziente-scheda-aachener-aphasie-test-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import RsaOspiteAnagraficaComponent from "../../rsagestioneospiti/components/RsaOspiteAnagraficaComponent.vue";
import RsaPazienteSchedaAachenerAphasieTestListComponent from "../components/RsaPazienteSchedaAachenerAphasieTestListComponent.vue";

export default {
    name: "RsaPazienteSchedaAachenerAphasieTestListPage",
    components: {
        SaPageLayout,
        RsaOspiteAnagraficaComponent,
        RsaPazienteSchedaAachenerAphasieTestListComponent,
    },
    data() {
        return {
            idAccettazione: null,
            pathResource: "/aacheneraphasietest",
            pathResourceAccettazione: "/accettazioni",
            linkback: "/rsagestioneospiti",
            showModalLoading: false,
            jsonData: {
                accettazioneAnagrafica: {},
                accettazionePrestazioni: {},
                accettazioneStati: [],
                accettazioneStruttura: {},
                accettazionePresidio: {},
            },
        };
    },
    mounted() {
        let me = this;
        me.idAccettazione = me.$route.query.idAccettazione;
        me.loadAccettazione();
    },
    watch: {
        "$route.query.idAccettazione"(idAccettazione) {
            let me = this;
            me.idAccettazione = idAccettazione;
            me.loadAccettazione();
        },
    },
    methods: {

        loadAccettazione() {
            let me = this;
            if (!me.idAccettazione) {
                me.loadAccettazioneError(new Error("Accettazione non specificata"));
                return;
            }
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceAccettazione + "/" + me.idAccettazione;
            axios
                .get(link)
                .then(me.loadAccettazioneSuccess)
                .catch(me.loadAccettazioneError);
        },
        loadAccettazioneSuccess(response) {
            let me = this;
            if (response.data.esito === false || !response.data.data) {
                me.loadAccettazioneError(new Error(response.data.messaggio || "Errore nel caricamento dei dati del paziente"));
                return;
            }
            me.jsonData = response.data.data;
            me.$refs.cmpRsaPazienteSchedaAachenerAphasieTestList.init(me.idAccettazione);
        },
        loadAccettazioneError(error) {
            let me = this;
            console.log(error);
            me.showModalLoading = false;
            me.$bvToast.toast("Errore nel caricamento dei dati del paziente", {
                title: "Errore",
                variant: "danger",
                solid: true,
            });
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onRefresh() {
            let me = this;
            me.loadAccettazione();
        },
    },
};
</script>

